import AnswerFlagConfiguration from '@app/src/pages/Configurations/ConfigurationsPages/AnswerFlag/AnswerFlagConfiguration'
import AuditLogConfig from '@app/src/pages/Configurations/ConfigurationsPages/AuditLog/AuditLogsConfig'
import AutomationsConfig from '@app/src/pages/Configurations/ConfigurationsPages/Automation/AutomationsConfig'
import FileRepository from '@app/src/pages/Configurations/ConfigurationsPages/FileRepository/FileRepository'
import UsersConfig from '@app/src/pages/Configurations/ConfigurationsPages/Users/UsersConfig'
import { CONFIGURATION_PAGE_IDS } from '@app/src/pages/Configurations/ConfigurationsScene'
import React from 'react'

import AiScreeningInfoPage from './ConfigurationsPages/AiScreening/AiScreeningInfoPage'
import AssessmentConfig from './ConfigurationsPages/Assessment/AssessmentConfig'
import CategoriesConfig from './ConfigurationsPages/Category/CategoriesConfig'
import ClaimsReviewConfig from './ConfigurationsPages/ClaimsReview/ClaimsReviewCollection'
import ColleaguesConfig from './ConfigurationsPages/Colleague/ColleaguesConfig'
import OrganizationCollection from './ConfigurationsPages/Organization/OrganizationCollection'
import OrganizationDetails from './ConfigurationsPages/Organization/OrganizationDetails'
import OrganizationInfoConfig from './ConfigurationsPages/OrganizationInfo/'
import OrganizationPreferencesConfig from './ConfigurationsPages/OrganizationSettings/OrganizationPreferencesConfig'
import BenchmarkAdminConfig from './ConfigurationsPages/Benchmark/BenchmarkAdminConfig'
import FlagRecalculationConfig from './ConfigurationsPages/ReportFlagAdmin/FlagRecalculationConfig'
import InherentRiskTabs from './ConfigurationsPages/RiskScreening/InherentRiskTabs'
import SuggestedContactsConfig from './ConfigurationsPages/SuggestedContacts/SuggestedContactsConfig'
import SustainabilityProfileConfig from './ConfigurationsPages/SustainabilityProfile/SustainabilityProfileConfig'
import AssessmentTemplateAdminConfig from './ConfigurationsPages/TemplateAdmin/AssessmentTemplateAdminConfig'
import QuestionnaireTemplateAdminConfig from './ConfigurationsPages/TemplateAdmin/QuestionnaireTemplateAdminConfig'
import TopicalRiskConfig from './ConfigurationsPages/TopicalRiskAdmin/TopicalRiskConfig'
import UserDetails from './ConfigurationsPages/Users/UserDetails'

interface Props {
  content: CONFIGURATION_PAGE_IDS
  configurationsSubPage?: string
}

const ConfigurationsContent: React.FC<Props> = function ({ content, configurationsSubPage }) {
  switch (content) {
    case CONFIGURATION_PAGE_IDS.Automations:
      return <AutomationsConfig />

    case CONFIGURATION_PAGE_IDS.AuditLogs:
      return <AuditLogConfig />

    case CONFIGURATION_PAGE_IDS.FileRepository:
      return <FileRepository />

    case CONFIGURATION_PAGE_IDS.Colleagues:
      return <ColleaguesConfig />

    case CONFIGURATION_PAGE_IDS.Categories:
      return <CategoriesConfig />

    case CONFIGURATION_PAGE_IDS.RiskScreening:
      return <InherentRiskTabs />

    case CONFIGURATION_PAGE_IDS.Assessments:
      return <AssessmentConfig />

    case CONFIGURATION_PAGE_IDS.Users:
      return configurationsSubPage ? <UserDetails id={configurationsSubPage} /> : <UsersConfig />

    case CONFIGURATION_PAGE_IDS.Organizations:
      return configurationsSubPage ? <OrganizationDetails id={configurationsSubPage} /> : <OrganizationCollection />

    case CONFIGURATION_PAGE_IDS.OrganizationInfo:
      return <OrganizationInfoConfig />

    case CONFIGURATION_PAGE_IDS.OrganizationPreferences:
      return <OrganizationPreferencesConfig />

    case CONFIGURATION_PAGE_IDS.SustainabilityProfile:
      return <SustainabilityProfileConfig />

    case CONFIGURATION_PAGE_IDS.ClaimsReview:
      return <ClaimsReviewConfig />

    case CONFIGURATION_PAGE_IDS.SuggestedContacts:
      return <SuggestedContactsConfig />

    case CONFIGURATION_PAGE_IDS.AssessmentsAdminConfiguration:
      return <AssessmentTemplateAdminConfig />

    case CONFIGURATION_PAGE_IDS.QuestionnairesAdminConfiguration:
      return <QuestionnaireTemplateAdminConfig />

    case CONFIGURATION_PAGE_IDS.TopicalRiskConfiguration:
      return <TopicalRiskConfig />

    case CONFIGURATION_PAGE_IDS.FlagRecalculationConfiguration:
      return <FlagRecalculationConfig />

    case CONFIGURATION_PAGE_IDS.BenchmarkAdminConfiguration:
      return <BenchmarkAdminConfig />

    case CONFIGURATION_PAGE_IDS.AiScreening:
      return <AiScreeningInfoPage />

    case CONFIGURATION_PAGE_IDS.AnswerFlags:
      return <AnswerFlagConfiguration />
  }
}

export default ConfigurationsContent
